import { BiologyCategoryInfo } from './index'

/**
 * 生物学科一级目录数据
 */
export const BIOLOGY_CATEGORIES: BiologyCategoryInfo[] = [
  {
    id: 'cell-biology',
    name: '细胞生物学',
    description: '作为核心基础模块,涵盖细胞结构与功能、细胞器特性、细胞代谢、物质跨膜运输、细胞分裂与增殖等内容,还包含微生物学相关基础知识点。',
    keywords: [
      '细胞结构',
      '细胞器',
      '线粒体',
      '叶绿体',
      '内质网',
      '高尔基体',
      '细胞膜',
      '跨膜运输',
      '胞吞胞吐',
      '细胞分裂',
      '有丝分裂',
      '减数分裂',
      '细胞周期',
      '细胞凋亡',
      '细胞自噬',
      '微生物',
      '细菌',
      '病毒'
    ]
  },
  {
    id: 'molecular-biology',
    name: '分子生物学',
    description: '常与生物化学、遗传学内容交叉考查,核心是DNA双螺旋结构、半保留复制,以及基因转录、翻译等基因表达过程,同时涉及蛋白质的合成与修饰等内容。',
    keywords: [
      'DNA',
      'RNA',
      '双螺旋结构',
      'DNA复制',
      '半保留复制',
      '转录',
      '翻译',
      '基因表达',
      '密码子',
      'mRNA',
      'tRNA',
      'rRNA',
      '启动子',
      '终止子',
      '剪接',
      'RNA加工',
      '蛋白质合成',
      '翻译后修饰'
    ]
  },
  {
    id: 'biochemistry',
    name: '生物化学',
    description: '聚焦生物体内的化学过程与物质,比如蛋白质、酶、核酸等生物大分子的结构和功能,ATP与ADP的能量转化,还有糖类、脂肪的代谢路径等。',
    keywords: [
      '蛋白质',
      '酶',
      '酶促反应',
      '酶活性',
      '核酸',
      '氨基酸',
      '多肽',
      'ATP',
      'ADP',
      '能量代谢',
      '糖酵解',
      '柠檬酸循环',
      '电子传递链',
      '氧化磷酸化',
      '光合作用',
      '卡尔文循环',
      '脂肪代谢',
      '糖代谢'
    ]
  },
  {
    id: 'plant-biology',
    name: '植物生物学',
    description: '包含植物解剖和生理两大核心,重点是种子植物的组织器官结构、光合作用、水分与养分运输,以及植物激素调控生长发育、植物的生殖方式与世代交替等。',
    keywords: [
      '植物解剖',
      '植物组织',
      '维管束',
      '木质部',
      '韧皮部',
      '叶片结构',
      '根系',
      '茎',
      '光合作用',
      '蒸腾作用',
      '水分运输',
      '养分运输',
      '植物激素',
      '生长素',
      '赤霉素',
      '细胞分裂素',
      '脱落酸',
      '乙烯',
      '向光性',
      '向地性',
      '植物生殖',
      '世代交替'
    ]
  },
  {
    id: 'animal-biology',
    name: '动物生物学',
    description: '以脊椎动物为核心,涵盖动物解剖和生理知识,像消化、呼吸、循环等系统的结构功能,神经与激素调节机制,还有动物的生殖发育和免疫体系等。',
    keywords: [
      '脊椎动物',
      '消化系统',
      '呼吸系统',
      '循环系统',
      '排泄系统',
      '神经系统',
      '内分泌系统',
      '激素调节',
      '神经调节',
      '反射',
      '突触',
      '神经递质',
      '免疫系统',
      '体液免疫',
      '细胞免疫',
      '抗原抗体',
      '生殖发育',
      '胚胎发育'
    ]
  },
  {
    id: 'genetics',
    name: '遗传学',
    description: '涉及孟德尔遗传定律、伴性遗传、基因突变与重组等内容,同时包含群体遗传学中基因频率的计算等知识点,是竞赛的重点模块之一。',
    keywords: [
      '孟德尔遗传',
      '分离定律',
      '自由组合定律',
      '连锁交换',
      '伴性遗传',
      '性染色体',
      '基因突变',
      '染色体畸变',
      '基因重组',
      '交叉互换',
      '遗传图谱',
      '连锁分析',
      '群体遗传学',
      '基因频率',
      '哈迪-温伯格平衡',
      '遗传漂变',
      '基因流'
    ]
  },
  {
    id: 'evolution',
    name: '生物演化',
    description: '单独列为重要内容,研究生物进化的机理,比如自然选择、生殖隔离、适应与物种形成等,还包括不同类群生物间的演化关系。',
    keywords: [
      '自然选择',
      '达尔文进化论',
      '适应',
      '物种形成',
      '生殖隔离',
      '地理隔离',
      '协同进化',
      '趋同进化',
      '趋异进化',
      '分子进化',
      '系统发育',
      '演化树',
      '化石证据',
      '比较解剖学',
      '同源器官',
      '痕迹器官'
    ]
  },
  {
    id: 'ecology',
    name: '生态学',
    description: '围绕生态系统展开,涵盖食物链与食物网、能量流动、生物地球化学循环,以及种群动态、群落演替,还有生物与环境的相互作用等内容。',
    keywords: [
      '生态系统',
      '食物链',
      '食物网',
      '能量流动',
      '能量金字塔',
      '生物量',
      '生产者',
      '消费者',
      '分解者',
      '碳循环',
      '氮循环',
      '磷循环',
      '水循环',
      '种群',
      '种群密度',
      '种群增长',
      'K值',
      'r值',
      '群落',
      '演替',
      '顶级群落',
      '生态位',
      '竞争',
      '捕食',
      '共生'
    ]
  },
  {
    id: 'animal-behavior',
    name: '动物行为学',
    description: '占比相对较小,主要考查动物的先天性行为与习得性行为,如昆虫趋光性、蜜蜂舞蹈传递信息等,同时涉及争斗行为的成因与行为系统的调控。',
    keywords: [
      '本能行为',
      '先天性行为',
      '习得性行为',
      '条件反射',
      '印随',
      '趋光性',
      '趋化性',
      '领域行为',
      '争斗行为',
      '求偶行为',
      '蜜蜂舞蹈',
      '动物通讯',
      '利他行为',
      '社会行为'
    ]
  },
  {
    id: 'systematics',
    name: '生物系统学',
    description: '聚焦生物各类群的结构和功能,研究典型生物之间的演化与生态关联,包含原核生物、真核生物等主要类群的特征辨析。',
    keywords: [
      '生物分类',
      '界门纲目科属种',
      '原核生物',
      '真核生物',
      '细菌',
      '古菌',
      '真菌',
      '原生生物',
      '藻类',
      '苔藓植物',
      '蕨类植物',
      '裸子植物',
      '被子植物',
      '无脊椎动物',
      '脊椎动物',
      '系统发育',
      '分类学'
    ]
  },
  {
    id: 'biotechnology',
    name: '生物技术',
    description: '属于应用类模块,涵盖发酵技术、基因编辑、生物体的遗传操纵等内容,同时涉及微生物培养、植物组织培养等实验相关的技术原理。',
    keywords: [
      '基因工程',
      'CRISPR',
      '基因编辑',
      'PCR',
      '克隆',
      '质粒',
      '载体',
      '转基因',
      '发酵技术',
      '微生物培养',
      '组织培养',
      '细胞培养',
      '蛋白质工程',
      '酶工程',
      '生物制药',
      '单克隆抗体',
      '疫苗'
    ]
  },
  {
    id: 'bioinformatics',
    name: '生物信息学',
    description: '是近年竞赛新增的适配国际奥赛的内容,侧重生物学数据的分析与解读,比如基因序列的比对、生物信息的挖掘等前沿相关知识。',
    keywords: [
      '序列比对',
      '基因组学',
      '转录组学',
      '蛋白质组学',
      '生物数据库',
      'BLAST',
      '系统发育分析',
      '基因预测',
      'RNA测序',
      '高通量测序',
      '生物信息分析',
      '进化树构建'
    ]
  },
  {
    id: 'developmental-biology',
    name: '发育生物学',
    description: '部分届次的实验或理论题会涉及,核心是生物体从受精卵到完整个体的发育过程,如卵裂、原肠胚形成,以及HOX基因对器官发育的调控等。',
    keywords: [
      '胚胎发育',
      '受精',
      '卵裂',
      '囊胚',
      '原肠胚',
      '三胚层',
      '外胚层',
      '中胚层',
      '内胚层',
      '器官发生',
      'HOX基因',
      '同源异形基因',
      '细胞分化',
      '细胞决定',
      '诱导',
      '形态发生',
      '再生'
    ]
  }
]
